import { render, staticRenderFns } from "./help-page.vue?vue&type=template&id=1c06269e&scoped=true&"
import script from "./help-page.vue?vue&type=script&lang=js&"
export * from "./help-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c06269e",
  null
  
)

export default component.exports